<div>
  <span>{{ 'vg.sortBy' | translate }}:</span>
  <button
    type="button"
    aria-pressed="false"
    class="sort--button button--no-border button button--tertiary u-ph----"
    (click)="isOpen = true"
  >
    <span>{{ sortLabel | translate }}</span>
  </button>
  <span>
    <svg-icon
      class="modified-item-icon-fill"
      [name]="sortIndicator"
      (click)="onSortToggled()"
      [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
    ></svg-icon>
  </span>
  <wfm-dropdown [(isOpen)]="isOpen" (isOutsideMousedown)="isOpen = $event">
    <div class="flex flex--col scrollable">
      <div>
        <div class="u-p--">
          <div class="flex flex--row flex--middle u-pb--">
            <svg-icon class="icon-fill" name="ico-sort-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
            <span class="text-16 u-ml-- no-select">{{ 'vg.sortBy' | translate }}</span>
          </div>
          <div>
            <div *ngFor="let item of sortableItemList" class="radio-wrapper">
              <label [for]="item.label + '-sort'" class="radio" [class.radio--disabled]="item.disabled">
                <input
                  type="radio"
                  name="sort_radio_group"
                  class="radio__input"
                  [id]="item.label + '-sort'"
                  [value]="item.column.id"
                  [(ngModel)]="checkedItem"
                  (click)="onSortItemChanged(item)"
                />
                <span class="radio__label">{{ item.label | translate }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="menu__item-divider" *ngIf="content.children.length != 0"></div>
        <div class="u-p--" #content [hidden]="content.children.length === 0">
          <ng-content></ng-content>
        </div>

        <ng-container *ngIf="enableResetSortButton">
          <div class="menu__item-divider"></div>
          <div class="u-p---">
            <button
              type="button"
              aria-pressed="false"
              (click)="onResetSort()"
              class="button--no-border button button--tertiary u-ph0 u-mh---"
              [disabled]="!isSorted"
            >
              <svg-icon
                name="ico-reset-16"
                class="button__icon button__icon--color"
                [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
              ></svg-icon>
              <span>{{ 'vg.resetSort' | translate }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </wfm-dropdown>
</div>
